module.exports = __webpack_public_path__ + "media/bootstrap-icons/recycle-e1a40cce.svg";